enum IVmsTypeEnum {
  PROWAND_PRO = 'Prowand Pro',
  FIELD_GLASS = 'Field Glass',
  AGILE_ONE = 'Agileone',
}

export default IVmsTypeEnum;
